module.exports = __webpack_public_path__ + "media/images/payments/ebay-dark-e7a661ae2f081827b2b386a565b66567.svg";